// app/src/lib/index.js — public entry for the security/data library.
// Bundled by vite.lib.config.js into app/dist/kanjo-lib.js, exposed as `window.kanjo`.

import * as cryptoLib from './crypto.js';
import { db, openDb, resetDb } from './db.js';
import * as tokenStore from './tokenStore.js';
import * as auth from './auth/cognitoClient.js';
import * as backup from './backup/index.js';
import * as plaid from './plaid/index.js';
import * as ocr from './ocr/index.js';
import * as reconciler from './plaid/reconciler.js';
import { configure, getConfig } from './config.js';
import * as sam from './sam/root.js';
import * as procurement from './procurement/index.js';
import * as cashflow from './cashflow/index.js';
import * as revenue from './revenue/index.js';
import * as scale from './scale/index.js';
import * as alerts from './alerts/index.js';
import * as delivery from './delivery/index.js';
import * as reportSignals from './reports/tileSignals.js';
import * as lock from './lock/deviceLock.js';
import * as demo from './demo.js';
import { track } from './track/index.js';
import * as crash from './crash/index.js';
import * as disclaimer from './legal/disclaimer.js';

/**
 * Public surface. Keep small and stable — the React components depend on it.
 * @namespace kanjo
 */
const kanjo = Object.freeze({
  configure,
  getConfig,
  crypto: cryptoLib,
  disclaimer,
  db,
  openDb,
  resetDb,
  tokenStore,
  auth,
  backup,
  plaid,
  ocr,
  reconciler,
  sam,
  procurement,
  cashflow,
  revenue,
  scale,
  alerts,
  delivery,
  reportSignals,
  lock,
  demo,
  track,
  crash,
});

if (typeof window !== 'undefined') window.kanjo = kanjo;
export default kanjo;
